import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export interface IDynamicReportModule {
  moduleId: string;
  name: string;
  description: string;
}

export interface IDynamicReportColumn {
  key: string;
  label: string;
  defaultVisible: boolean;
  locked?: boolean;
}

export interface IDynamicReportFilter {
  key: string;
  label: string;
  type: 'DATE_RANGE' | 'MONTH_YEAR' | 'EMPLOYEE_PICKER' | 'DEPARTMENT_PICKER' | 'SELECT' | 'MULTISELECT';
  required?: boolean;
  options?: Array<{ value: string; label: string }>;
  source?: string;
}

export interface IDynamicReportSchema {
  moduleId: string;
  name: string;
  description: string;
  timeline?: {
    type: 'DATE_RANGE' | 'MONTH_YEAR';
    required: boolean;
    maxDays?: number;
  };
  employees?: {
    type: 'EMPLOYEE_PICKER';
    required: boolean;
  };
  departments?: {
    type: 'DEPARTMENT_PICKER';
    required: boolean;
  };
  customFilters?: IDynamicReportFilter[];
  columns: IDynamicReportColumn[];
}

export const dynamicReportsApi = createApi({
  reducerPath: 'dynamicReportsApi',
  baseQuery,
  tagTypes: ['DynamicReports'],
  endpoints: (builder) => ({
    getReportModules: builder.query<IDynamicReportModule[], void>({
      query: () => '/v2/dynamic-reports/modules',
      transformResponse: (raw: any) => raw.data || raw || [],
    }),
    getReportSchema: builder.query<IDynamicReportSchema, string>({
      query: (moduleId) => `/v2/dynamic-reports/modules/${moduleId}/schema`,
      transformResponse: (raw: any) => raw.data || raw,
    }),
    downloadReport: builder.mutation<
      Blob,
      { moduleId: string; filters: Record<string, any>; columns: string[] }
    >({
      query: ({ moduleId, filters, columns }) => ({
        url: `/v2/dynamic-reports/modules/${moduleId}/download`,
        method: 'POST',
        body: { filters, columns },
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetReportModulesQuery,
  useGetReportSchemaQuery,
  useDownloadReportMutation,
} = dynamicReportsApi;
